<template>
  <div class="container" :class="{dragging: dragging}">

    <!-- Modal -->
    <div id="myModal" class="modal" :class="{showModal: showModal}">
      <div class="uploadcare--dialog" style="opacity: 1;">

        <div class="uploadcare--dialog__container">
          <div class="uploadcare--panel uploadcare--dialog__panel">

            <h2 class="uploadcare--text">Choose a reason</h2>
            <button type="button" class="close uploadcare--button uploadcare--button_icon uploadcare--button_muted uploadcare--dialog__close" data-dismiss="modal" aria-label="Close" @click="showModal = false">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="d-flex">
              <ul class="list-unstyled reasons-list">
                <li class="lead" v-for="reason in recommendedReasons">
                  <a href="#" @click.prevent="setReasonFromModal(reason.reason)" data-dismiss="modal">{{reason.reason}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    </div>

    <div class="">
      <div class="">

        <div class="">
          <h2 class="text-center">
            {{ header }}
          </h2>
          <div class="lead intro-text mb-5" v-html="copy"></div>
        </div>

        <div class="row">
          <div class="col-md-4  mb-4">
            <h4 class="mb-1">
              <slot name="step-1-text"></slot>
            </h4>
            <slot name="step-1"></slot>
            <button type="button" class="btn btn-secondary mt-2" id="file" name="file" @click.prevent="openUploadCare()">
              <slot name="step-1-button-text"></slot>
            </button>
            <input type="hidden" role="uploadcare-uploader" name="my_file" />
          </div>

          <div class="col-md-4  mb-4">
            <h4 class="mb-1">
              <slot name="step-2-text"></slot>
            </h4>
            <slot name="step-2"></slot>
            <textarea class="mt-1 mb-2 form-control" maxlength="80" rows="3" name="name" v-model="text" :placeholder="buttontwoplaceholder" @input="redraw" @propertychange="changeText()"></textarea>
            <div class="">
              <button type="button" class="btn btn-secondary" data-toggle="modal" data-target="#myModal" @click.prevent="openModal()">
                <slot name="step-2-button-text"></slot>
              </button>
            </div>
          </div>
          <div class="col-md-4 mb-4">
            <h4 class="mb-1">
              <slot name="step-3-text"></slot>
            </h4>
            <slot name="step-3"></slot>
            <input type="email" class="mt-1 mb-2 form-control" name="email" v-model="email"></input>
          </div>

        </div>

        <transition name="fade">
          <div class="zoom mb-2" v-if="showZoom">
            <div class="">

              <span>Zoom</span>
              <div class="d-inline-block zoom-range-container">
                <input type="range" @input="setZoom($event)" @change="setZoom($event)" value="1" :min="zoomBounds.min" :max="zoomBounds.max" step="0.01">
              </div>
            </div>
          </div>
        </transition>
        <div id="generatorCanvas">
        </div>
        <div class="">

          <button v-if="!openShareMenu" class="btn btn-primary mt-3 " @click.stop="uploadAndShare">
            <span v-if="!uploading">{{ buttonText }}</span>
            <span v-else>
              <i class="fa fa-spinner spinner fa-pulse"></i>
            </span>
          </button>
          <div class="upload-and-share-container mt-3" v-else>
            <a href="#" class="btn btn-secondary" @click.prevent="facebookShare">
              <div class="">
                Share on
                <i class="fa fa-facebook"></i>
              </div>
            </a>
            <hr/>
            <a :href="twitterShareUrl" class="btn btn-secondary" target="_blank" @click="gaTwitterEvent">
              <div class="">
                Share on
                <i class="fa fa-twitter"></i>
              </div>
            </a>
            <hr/>
            <a href="#" @click.prevent="downloadImage" class="btn btn-secondary" @click="gaDownloadEvent">
              <div class="">
                Download Image
              </div>
            </a>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import P5 from 'p5'
//import offscreenSketch from './offscreen-markless-sketch.js'
import sketch from './onscreen.js'
import uploadcare from 'uploadcare-widget'

export default {
  props: [
    'buttontwoplaceholder',
    'button-text',
    'copy',
    'dev-mode',
    'header',
    'instructions',
    'locale',
    'reasons',
    'share-text'
  ],
  data() {
    return {
      automaticallyDownload: true,
      defaultText: 'You control your own body and I respect your choices.',
      dragging: false,
      dragStart: {
        x: 0,
        y: 0
      },
      draw: false,
      email: null,
      file: null,
      img: null,
      markedImage: null,
      mainText: {
        fill: 255,
        bottom: 20,
        left: 20,
        size: 55
      },
      offscreenMarkless: null,
      offset: {
        x: 0,
        y: 0
      },
      onscreen: null,
      openShareMenu: false,
      originalImageUrl: null,
      prevOffset: {
        x: 0,
        y: 0
      },
      imageUrl: null,
      shareUrl: null,
      publicKey: '0b2a58ca6ea970f039e4',
      recommendedReason: null,
      recommendedReasons: null,
      savedImageUrl: null,
      craftEntryId: null,
      showModal: null,
      showZoom: false,
      text: '',
      textColor: '#000',
      textWidth: null,
      unmarkedImage: null,
      uploadedMessage: null,
      uploading: false,
      zoom: 1.0,
      zoomBounds: {
        min: 1.0,
        max: 4.0
      }
    }
  },
  mounted() {
    this.onscreen = new P5(this.processingSketch, 'generatorCanvas')
    //this.offscreenMarkless = new P5(this.offscreenProcessingSketch, 'offscreenMarkless')

    this.onscreen.disableFriendlyErrors = true;
    //    this.offscreenMarkless.disableFriendlyErrors = true;

  },
  created() {
    Axios.get('/recommended-reasons.json?locale=' + this.locale)
      .then((response) => {
        this.recommendedReasons = response.data.data
        this.generateDefaultText()
      })
  },
  methods: {
    gaEvent(category, action, label) {
      if (typeof ga !== 'undefined') {
        ga('send', {
          hitType: 'event',
          eventCategory: category,
          eventAction: action,
          eventLabel: label
        })
      }
    },
    gaDownloadEvent() {
      this.gaEvent('button', 'download', 'Downloaded the image')
    },
    gaTwitterEvent() {
      this.gaEvent('button', 'share', 'Tweeted')
    },
    changeText() {
      this.gaEvent('input', 'input', 'Input a new reason')
      this.redraw()
    },
    getFormattedDate() {
      const d = new Date()
      return d.getFullYear() +
        '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) +
        '-' + d.getDate() +
        ' ' + (d.getHours() < 10 ? '0' : '') + d.getHours() +
        ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes() +
        ':' + (d.getSeconds() < 10 ? '0' : '') + d.getSeconds()
    },
    generateDefaultText() {
      if (this.recommendedReasons) {
        this.defaultText = this.recommendedReasons[Math.floor(Math.random() * this.recommendedReasons.length)].reason
      }
    },
    getTextHeight() {
      this.onscreen.textHeight()
    },
    processingSketch: sketch,
    //offscreenProcessingSketch: offscreenSketch,
    openUploadCare() {
      this.gaEvent('button', 'click', 'Clicked to upload an image')
      this.openShareMenu = false;
      var singleWidget = uploadcare.SingleWidget('[role=uploadcare-uploader]');
      // uploadcare.start({
      //   publicKey: this.publicKey,
      //   imagesOnly: true
      // })
      singleWidget.openDialog(null, {
        publicKey: this.publicKey,
        imagesOnly: true
        // uploadcareLive: false
      });

      singleWidget.onUploadComplete(function(info) {
        this.originalImageUrl = info.cdnUrl
        this.showZoom = true
        this.setImage()
      }.bind(this));
    },
    openModal() {
      this.showModal = true
    },
    setImage() {
      this.gaEvent('image', 'upload', 'Uploaded an image')
      this.onscreen.setImage()
      this.offset.x = 0
      this.offset.y = 0
      this.zoom = this.zoomBounds.min
      this.redraw()
      // this.zoom = (this.zoomBounds.max - this.zoomBounds.min) / 2.0 + this.zoomBounds.min
    },
    uploadAndShare() {
      this.gaEvent('button', 'click', 'Clicked Download and Share')


      // Save the image with no watermark to craft as an approvable reason
      // Save the image with the watermark to craft and pass back the URL
      // Once the URL is passed back, the menu appears with Twitter and Facebook links to the watermarked image
      this.uploading = true
      this.onscreen.save()

    },
    facebookShare() {

      FB.ui({
        method: 'share',
        href: this.shareUrl,
        // method: 'feed',
        // picture: this.imageUrl,

        //quote: this.translateReason + " #" + this.reasonNumber + ": " + this.textForCanvas,
        hashtag: '#yoteapoyo',
        mobile_iframe: true
        //display: 'iframe',


      }, function(response) {
        console.log(response);
      });

      this.gaEvent('button', 'share', 'Shared on Facebook')

    },
    uploadFile(imageData) {
      const imageFile = this.convertCnvForUpload(imageData)
      console.log('imageFile', imageFile)
      const formData = new FormData()
      const dateString = this.getFormattedDate()
      //formData.append('action', 'guestEntries/saveEntry')
      // Reasons section
      formData.append('sectionId', '3')
      formData.append('fields[reason]', this.textForCanvas)
      formData.append('fields[reasonNumber]', this.reasonNumber)
      formData.append('fields[originalImageUrl]', this.originalImageUrl)
      formData.append('fields[reasonImage]', imageFile, 'reason-' + this.reasonNumber + '.png')
      formData.append('postDate', dateString)
      formData.append('fields[email]', this.email)


      Axios.post('/actions/guestEntries/saveEntry', formData, {
        headers: {
          'content-type': 'multipart/form-data',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then((response) => {
          console.log('response', response.data.id);
          this.craftEntryId = response.data.id;
          Axios.get('/actions/familiar/entry/getImageUrl', { params: { id: this.craftEntryId } }).then((response) => {
            this.imageUrl = response.data;
            this.shareUrl = this.domain + '/' + (this.locale === 'en_us' ? 'en' : 'es') + '/reason/' + this.craftEntryId;
            this.twitterShareUrl = 'http://www.twitter.com/intent/tweet?hashtags=yoteapoyo&via=NLIRH&text=' + encodeURIComponent(this.translateReason + " #" + this.reasonNumber + ": " + this.textForCanvas + " " + this.shareUrl);
            this.uploading = false
            this.openShareMenu = true

          })
          //this.uploadedResponseId = response.data.id

        })
        .catch((error) => {
          console.warn('craft error', error)
        })


    },
    convertCnvForUpload(imageData, filename) {
      //this.file = cnv.imageData
      let png = imageData.split(',')[1]
      const blob = new Blob([this.fixBinary(window.atob(png))], { type: 'image/png' })
      return blob;
      //return new File([blob], filename + '.png', { type: 'image/png' })
    },
    fixBinary(bin) {
      var length = bin.length;
      var buf = new ArrayBuffer(length);
      var arr = new Uint8Array(buf);
      for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
      }
      return buf;
    },
    redraw() {
      this.onscreen.redraw()
      //this.offscreenMarkless.redraw()
    },
    selectRecommendedReason(e) {
      this.recommendedReason = window.selectedReason
      this.redraw()
    },
    setReasonFromModal(reason) {
      this.gaEvent('input', 'chose', 'Chose a reason')
      this.text = reason
      this.showModal = false
      this.redraw()
    },
    setZoom(e) {
      this.zoom = parseFloat(e.target.value)
      let tempZoom = parseFloat(e.target.value)
      // if zoom this much would bring the image's bounds within the frame, set it to the minimum possible, otherwise set it
      if (this.offset.x + this.img.width * tempZoom * this.imageScale < this.onscreen.width) {
        tempZoom = (this.onscreen.width - this.offset.x) / (this.img.width * this.imageScale)
      } else if (this.offset.y + this.img.height * tempZoom * this.imageScale < this.onscreen.height) {
        tempZoom = (this.onscreen.height - this.offset.y) / (this.img.height * this.imageScale)
      }
      this.zoom = tempZoom
      this.redraw()
    },
    downloadImage() {
      this.onscreen.downloadMarkedImage()
    }
  },
  watch: {
    'selectedReason': 'selectedRecommendedReason',
    text() {
      this.openShareMenu = false;
    }
  },
  computed: {
    translateReason() {
      if (this.locale === 'en_us') {
        return 'Reason'
      } else if (this.locale === 'es') {
        return 'Razón'
      } else {
        return 'Reason'
      }
    },
    bounds() {
      if (this.img) {
        return {
          x: this.offset.x,
          y: this.offset.y,
          w: (this.img.width) * this.zoom * this.imageScale,
          h: (this.img.height) * this.zoom * this.imageScale,
          xend: this.offset.x + (this.img.width) * this.zoom * this.imageScale,
          yend: this.offset.y + (this.img.height) * this.zoom * this.imageScale
        }
      }
    },
    imageScale() {
      // since the zoomBounds.min is 1, calculating the imageScale and multiplying by 1 will never zoom the image too far
      let imageScale = 1
      if (this.onscreen && this.img) {
        if (this.img.width > this.img.height) {
          imageScale = this.onscreen.height / this.img.height
        } else {
          imageScale = this.onscreen.width / this.img.width
        }
      }
      return imageScale
    },
    capitalText() {
      return this.textForCanvas.toUpperCase()
    },
    domain() {
      // return this.devMode === 'true' ? 'http://yoteapoyo.dev' : 'http://yoteapoyo.org'
      return 'https://yoteapoyo.org'
    },
    reasonNumber() {
      return parseInt(this.reasons) + 1
    },
    returns() {
      return this.capitalText.split("\n").length - 1
    },
    selectedReason() {
      // this.text = window.selectedReason
      return window.selectedReason
    },
    textForCanvas() {
      return this.text ? this.text : this.defaultText
    }
  }
}
</script>



// WEBPACK FOOTER //
// generator.vue?40091b14